import { render, staticRenderFns } from "./LanguageSetter.vue?vue&type=template&id=50d4cc52&"
import script from "./LanguageSetter.vue?vue&type=script&lang=js&"
export * from "./LanguageSetter.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSetter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LanguageSetter.vue"
export default component.exports